import React from "react";
import PropTypes from "prop-types";

import { QuantityWrapper } from "./QuantitySelector.styles";

const MIN_INPUT = 1;
const MAX_INPUT = 999;

class QuantitySelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      quantity: this.props.quantity || 1,
      inputValue: this.props.quantity ? this.props.quantity.toString() : "1" // can be empty string
    };
  }

  updateQuantity = newQuantity => {
    if (newQuantity !== 0) {
      this.setState(
        () => ({
          quantity: newQuantity,
          inputValue: newQuantity.toString()
        }),
        this.props.onChange(newQuantity)
      );
    }
  };

  handleClick = action => {
    const currentQuantity = this.state.quantity;

    if (action === "decrease" && currentQuantity !== MIN_INPUT) {
      this.updateQuantity(currentQuantity - 1);
    } else if (action === "increase" && currentQuantity !== MAX_INPUT) {
      this.updateQuantity(currentQuantity + 1);
    }
  };

  handleInput = event => {
    const { value } = event.target;

    if (value === "") {
      this.setState(() => ({
        inputValue: value
      }));
    } else if (
      parseInt(value, 10) >= MIN_INPUT &&
      parseInt(value, 10) <= MAX_INPUT
    ) {
      this.updateQuantity(parseInt(value, 10));
    }
  };

  render() {
    return (
      <QuantityWrapper>
        <label
          className="lfc-product-quantity-label"
          htmlFor="lfc-product-quantity-field"
        >
          {this.props.labelText}
        </label>
        <div className="lfc-product-quantity-wrapper">
          <span
            className={`lfc-quantity-minus${
              this.state.quantity === MIN_INPUT ? " disabled" : ""
            }`}
            onClick={() => {
              this.handleClick("decrease");
            }}
          />
          <input
            id="lfc-product-quantity-field"
            className="lfc-product-quantity-field"
            type="number"
            value={this.state.inputValue}
            min={MIN_INPUT}
            max={MAX_INPUT}
            name="lfc-product-quantity"
            onChange={this.handleInput}
          />
          <span
            className={`lfc-quantity-plus${
              this.state.quantity === MAX_INPUT ? " disabled" : ""
            }`}
            onClick={() => {
              this.handleClick("increase");
            }}
          />
        </div>
      </QuantityWrapper>
    );
  }
}

QuantitySelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  quantity: PropTypes.number.isRequired,
  labelText: PropTypes.string,
}

export default QuantitySelector;
